module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/icon_number_04-41fa76bc3674d95368cb9607aed18891.svg";